

import React from "react";

// reactstrap components
import {
    Table,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
    DropdownToggle,
} from "reactstrap";
import WarehouseDataService from "../../services/WarehouseDataService";

class Warehouses extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            warehouseToDisabled: {},
        }
        this.warehouseDataService = new WarehouseDataService();
    }

    toggleModal = (warehouse) => {
        this.props.toggleModal("formWarehouseModal", "edit", warehouse)
    }

    toggleModals = (state, warehouse) => {
        this.setState({
            [state]: !this.state[state],
            warehouseToDisabled: warehouse,
        });
    };

    handleResponse(data, successMessage) {
        if (data.header.status_code !== 200) {
            let errorMessages = []
            data?.data?.map((data) => {
                errorMessages.push(data?.error_message)
            })
            this.setState({ errorMessages: errorMessages })
        } else {
            this.toggleModals("notificationModal")
            this.props.setSuccessMessage(successMessage)
            this.setState({ currentWarehouse: {} })
            this.props.fetchData()
        }
    }

    render() {
        return (
            <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                    <tr>
                        <th scope="col">Nama warehouse</th>
                        <th scope="col" />
                    </tr>
                </thead>
                <tbody>
                    {this.props.warehouses.length > 0 && this.props.warehouses.filter(warehouse => warehouse).map((warehouse) => (
                        <tr style={{ cursor: 'pointer' }}>
                            <th scope="row" onClick={() => this.toggleModal(warehouse)}>
                                {warehouse.warehouse_name}
                            </th>
                            <td className="text-right">
                                <UncontrolledDropdown>
                                    <DropdownToggle
                                        className="btn-icon-only text-light"
                                        role="button"
                                        size="sm"
                                        color=""
                                        onClick={(e) => e.preventDefault()}
                                    >
                                        <i className="fas fa-ellipsis-v" />
                                    </DropdownToggle>
                                    <DropdownMenu className="dropdown-menu-arrow" right>
                                        <DropdownItem
                                            onClick={() => this.toggleModal(warehouse)}
                                        >
                                            Ubah
                                        </DropdownItem>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        )
    };
}

export default Warehouses;
